export default "__VITE_ASSET__n9eWg0$w__"